module.exports = __webpack_public_path__ + "img/Gelaatsbescherming_verplicht.decf65ab.jpg";